import { render, staticRenderFns } from "./FirstAccessPage.vue?vue&type=template&id=88c44e6e&scoped=true"
import script from "./FirstAccessPage.vue?vue&type=script&lang=js"
export * from "./FirstAccessPage.vue?vue&type=script&lang=js"
import style0 from "./FirstAccessPage.vue?vue&type=style&index=0&id=88c44e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c44e6e",
  null
  
)

export default component.exports